export const tooltipPopperProps = {
    modifiers: [
        {
            name: "offset",
            options: {
                offset: [0, -6]
            }
        }
    ]
};
/**
 * @deprecated This is part of theme so you will get those props by default, no need to use this anymore
 */
export const commonTooltipProps = {
    arrow: true,
    placement: "top",
    PopperProps: tooltipPopperProps
};
//# sourceMappingURL=tooltip.js.map